import { render } from "./SearchResultsCompany.vue?vue&type=template&id=5cc98bfe&scoped=true"
import script from "./SearchResultsCompany.vue?vue&type=script&lang=js"
export * from "./SearchResultsCompany.vue?vue&type=script&lang=js"

import "./SearchResultsCompany.vue?vue&type=style&index=0&id=5cc98bfe&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cc98bfe"]])

export default __exports__